export function installNumericInputEditing(root = document) {
  let newlyFocused = null;
  const focus = event => {
    const input = event.target;
    if (!input.matches?.('input[type="number"]')) return;
    newlyFocused = input;
    input.select();
    setTimeout(() => { if (root.activeElement === input) input.select(); }, 0);
  };
  const mouseup = event => {
    if (event.target === newlyFocused) {
      event.preventDefault();
      newlyFocused = null;
    }
  };
  root.addEventListener('focusin', focus);
  root.addEventListener('mouseup', mouseup);
  return () => {
    root.removeEventListener('focusin', focus);
    root.removeEventListener('mouseup', mouseup);
  };
}
